import postDocFormModel from "./postDocFormModel";
const {
  formField: {
    photo,
    //page1
    email,
    password,
    titleNameEng,
    firstNameEng,
    middleNameEng,
    lastNameEng,
    titleNameThai,
    firstNameThai,
    middleNameThai,
    lastNameThai,
    gender,
    dateOfBirth,
    maritalStatus,
    bloodType,
    idCard,
    nationality,

    //page2
    yearOfTheContract,
    faculty,
    department,
    mobileThai,
    mobileCountry,
    studentId,
    mentor_id,
    mentorName,
    mentorEmail,
    startFellowship,
    contractEnd,
    fieldResearch,
    addressInThailand,
    addressInTheCountryOfResidence,

    //page3
    nameOfTheBachelorDegree,
    graduatedUniversityInstituteBachelorDegree,
    countryBachelorDegree,
    dateOfBachelorDegreeGraduation,
    nameOfMasterDegree,
    graduatedUniversityInstituteMasterDegree,
    countryMasterDegree,
    dateOfMasterDegreeGraduation,
    doctoralDegreeBackground,
    graduatedUniversityInstituteDoctoral,
    countryDoctoral,
    dateGraduationDoctoral,

    // Page 4
    workingExperienceList,
    publication,
    awards,
    cvOrResume
  }
} = postDocFormModel;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [photo.name]: null,
  [email.name]: "",
  [password.name]: "",
  [titleNameEng.name]: "",
  [firstNameEng.name]: "",
  [middleNameEng.name]: "",
  [lastNameEng.name]: "",
  [titleNameThai.name]: "",
  [firstNameThai.name]: "",
  [middleNameThai.name]: "",
  [lastNameThai.name]: "",
  [gender.name]: "",
  [dateOfBirth.name]: "",
  [maritalStatus.name]: "",
  [bloodType.name]: "",
  [idCard.name]: "",
  [nationality.name]: "",

  [yearOfTheContract.name]: "",
  [faculty.name]: "",
  [department.name]: "",
  [mobileThai.name]: "",
  [mobileCountry.name]: "",
  [studentId.name]: "",
  [mentor_id.name]: "",
  [mentorName.name]: "",
  [mentorEmail.name]: "",
  [startFellowship.name]: "",
  [contractEnd.name]: "",
  [fieldResearch.name]: "",
  [addressInThailand.name]: "",
  [addressInTheCountryOfResidence.name]: "",

  [nameOfTheBachelorDegree.name]: "",
  [graduatedUniversityInstituteBachelorDegree.name]: "",
  [countryBachelorDegree.name]: "",
  [dateOfBachelorDegreeGraduation.name]: "",
  [nameOfMasterDegree.name]: "",
  [graduatedUniversityInstituteMasterDegree.name]: "",
  [countryMasterDegree.name]: "",
  [dateOfMasterDegreeGraduation.name]: "",
  [doctoralDegreeBackground.name]: "",
  [graduatedUniversityInstituteDoctoral.name]: "",
  [countryDoctoral.name]: "",
  [dateGraduationDoctoral.name]: "",

  [workingExperienceList.name]: [
    {
      [workingExperienceList.subMenu[0].position.name]: "",
      [workingExperienceList.subMenu[0].companyOrganization.name]: "",
      [workingExperienceList.subMenu[0].country.name]: "",
      [workingExperienceList.subMenu[0].started.name]: "",
      [workingExperienceList.subMenu[0].ended.name]: "",
      [workingExperienceList.subMenu[0].stillInRole.name]: false
    }
  ],
  [publication.name]: "",
  [awards.name]: "",
  [cvOrResume.name]: null
};
